// extracted by mini-css-extract-plugin
export default {"spacing":"ResetPassword_spacing__Uq84Q","message":"ResetPassword_message__fqbr+"};